import {
    useEffect,
    useState
} from "react";

import {
    useParams,useNavigate
} from "react-router-dom";

import wmsRecurringScheduleService
    from "../../services/wmsRecurringScheduleService";

function RecurringScheduleDetailsPage() {

    const {
        scheduleId
    } = useParams();
    const navigate =     useNavigate();

    const [loading, setLoading] =
        useState(true);

    const [schedule, setSchedule] =
        useState(null);
    const [executionHistory, setExecutionHistory] =
    useState([]);

    
    async function handleResume() {

        if (

            !window.confirm(

                `Resume schedule "${schedule.schedule_name}"?`

            )

        ) {

            return;

        }

        try {

            await wmsRecurringScheduleService.resumeSchedule(

                schedule.id

            );

            alert(

                "Schedule resumed successfully."

            );

            await refreshPage();

        }

        catch (err) {

            console.error(err);

            alert(

                "Failed to resume schedule."

            );

        }

    }
    async function handlePause() {

        if (

            !window.confirm(

                `Pause schedule "${schedule.schedule_name}"?`

            )

        ) {

            return;

        }

        try {

            await wmsRecurringScheduleService.pauseSchedule(

                schedule.id

            );

            alert(

                "Schedule paused successfully."

            );

            await refreshPage();

        }

        catch (err) {

            console.error(err);

            alert(

                "Failed to pause schedule."

            );

        }

    }
    
        async function loadSchedule() {

            try {

                const data =
                    await wmsRecurringScheduleService.getSchedule(
                        scheduleId
                    );

                setSchedule(
                    data
                );

            }

            catch (err) {

                console.error(err);

            }

        }
       
        async function loadExecutionHistory() {

            try {

                const history =
                    await wmsRecurringScheduleService.getExecutionHistory(
                        scheduleId
                    );

                console.log(
                    "Execution History",
                    history
                );

                setExecutionHistory(
                    history
                );

            }

            catch (err) {

                console.error(err);

                setExecutionHistory([]);

            }

        }
        async function refreshPage() {

            try {

                setLoading(true);

                await loadSchedule();

                await loadExecutionHistory();

            }

            catch (err) {

                console.error(err);

            }

            finally {

                setLoading(false);

            }

        }


   useEffect(() => {

        refreshPage();

    }, [scheduleId]);

    if (loading) {

        return (

            <div className="container-fluid p-4">

                Loading...

            </div>

        );

    }

    return (

        <div className="container-fluid">

            <div className="d-flex justify-content-between align-items-center mb-3">

                <div>

                    <button
                        className="btn btn-link ps-0"
                        onClick={() => navigate(-1)}
                    >

                        <i className="fas fa-arrow-left me-2" />

                        Back

                    </button>

                    <h4 className="mb-1">

                        Recurring Schedule Details

                    </h4>

                    <small className="text-muted">

                        View recurring schedule information

                    </small>

                </div>

                <div className="d-flex gap-2">

                    <button
                        className="btn btn-primary"
                        onClick={() =>
                            console.log(
                                "Edit",
                                schedule.id
                            )
                        }
                    >

                        <i className="fas fa-edit me-2" />

                        Edit

                    </button>

                    {schedule.status === "ACTIVE" && (

                        <button
                            className="btn btn-warning"
                            onClick={handlePause}
                        >

                            <i className="fas fa-pause me-2" />

                            Pause

                        </button>

                    )}

                    {schedule.status === "PAUSED" && (

                        <button
                            className="btn btn-success"
                            onClick={handleResume}
                        >

                            <i className="fas fa-play me-2" />

                            Resume

                        </button>

                    )}

                    {schedule.status !== "CANCELLED" && (

                        <button
                            className="btn btn-danger"
                            onClick={() =>
                                console.log(
                                    "Cancel",
                                    schedule.id
                                )
                            }
                        >

                            <i className="fas fa-times me-2" />

                            Cancel

                        </button>

                    )}

                </div>

            </div>

            <hr />

            <hr />

            <div className="card mb-3">

            <div className="card-header">

                <strong>

                    General Information

                </strong>

            </div>

            <div className="card-body">

                <div className="row">

                    <div className="col-md-6 mb-3">

                        <label className="form-label fw-bold">

                            Schedule Name

                        </label>

                        <div>

                            {schedule.schedule_name}

                        </div>

                    </div>

                    <div className="col-md-3 mb-3">

                        <label className="form-label fw-bold">

                            Status

                        </label>

                        <div>

                            <span
                                className={`badge ${
                                    schedule.status === "ACTIVE"
                                        ? "bg-success"
                                        : schedule.status === "PAUSED"
                                        ? "bg-warning text-dark"
                                        : "bg-danger"
                                }`}
                            >

                                {schedule.status}

                            </span>

                        </div>

                    </div>

                    <div className="col-md-3 mb-3">

                        <label className="form-label fw-bold">

                            Priority

                        </label>

                        <div>

                            {schedule.priority}

                        </div>

                    </div>

                    <div className="col-md-3 mb-3">

                        <label className="form-label fw-bold">

                            Work Mode

                        </label>

                        <div>

                            {schedule.work_mode}

                        </div>

                    </div>

                    <div className="col-md-3 mb-3">

                        <label className="form-label fw-bold">

                            Frequency

                        </label>

                        <div>

                            {schedule.frequency}

                        </div>

                    </div>

                    <div className="col-md-3 mb-3">

                        <label className="form-label fw-bold">

                            Interval

                        </label>

                        <div>

                            {schedule.interval_value}

                        </div>

                    </div>

                    <div className="col-md-3 mb-3">

                        <label className="form-label fw-bold">

                            Execution Time

                        </label>

                        <div>

                            {schedule.execution_time}

                        </div>

                    </div>

                    <div className="col-md-3 mb-3">

                        <label className="form-label fw-bold">

                            Start Date

                        </label>

                        <div>

                            {schedule.start_date}

                        </div>

                    </div>

                    <div className="col-md-3 mb-3">

                        <label className="form-label fw-bold">

                            End Date

                        </label>

                        <div>

                            {schedule.end_date || "-"}

                        </div>

                    </div>

                    <div className="col-md-3 mb-3">

                        <label className="form-label fw-bold">

                            Next Run

                        </label>

                        <div>

                            {schedule.next_run_date || "-"}

                        </div>

                    </div>

                    <div className="col-md-3 mb-3">

                        <label className="form-label fw-bold">

                            Last Run

                        </label>

                        <div>

                            {schedule.last_run_date || "-"}

                        </div>

                    </div>

                </div>

            </div>

        </div>
<div className="card mb-3">

    <div className="card-header">

        <strong>

            Work Information

        </strong>

    </div>

    <div className="card-body">

        <div className="row">

            <div className="col-md-4 mb-3">

                <label className="form-label fw-bold">

                    Work Mode

                </label>

                <div>

                    {schedule.work_mode}

                </div>

            </div>

            <div className="col-md-4 mb-3">

                <label className="form-label fw-bold">

                    Template

                </label>

                <div>

                    {schedule.template_name || "-"}

                </div>

            </div>

            <div className="col-md-4 mb-3">

                <label className="form-label fw-bold">

                    Checklist

                </label>

                <div>

                    {schedule.checklist_name || "-"}

                </div>

            </div>

            <div className="col-md-4 mb-3">

                <label className="form-label fw-bold">

                    Team

                </label>

                <div>

                    {schedule.team_name || "-"}

                </div>

            </div>

            <div className="col-md-4 mb-3">

                <label className="form-label fw-bold">

                    Calendar

                </label>

                <div>

                    {schedule.calendar_name || "-"}

                </div>

            </div>

            <div className="col-md-4 mb-3">

                <label className="form-label fw-bold">

                    Owner User

                </label>

                <div>

                    {schedule.owner_user_id || "-"}

                </div>

            </div>

            <div className="col-md-6 mb-3">

                <label className="form-label fw-bold">

                    SLA Policy

                </label>

                <div>

                    {schedule.sla_policy_name || "-"}

                </div>

            </div>

            <div className="col-md-6 mb-3">

                <label className="form-label fw-bold">

                    Escalation Policy

                </label>

                <div>

                    {schedule.escalation_policy_name || "-"}

                </div>

            </div>

        </div>

    </div>

</div>

<div className="card mb-3">

    <div className="card-header">

        <strong>

            Execution Settings

        </strong>

    </div>

    <div className="card-body">

        <div className="row">

            <div className="col-md-4 mb-3">

                <label className="form-label fw-bold">

                    Pending Work Strategy

                </label>

                <div>

                    {schedule.pending_work_strategy}

                </div>

            </div>

            <div className="col-md-4 mb-3">

                <label className="form-label fw-bold">

                    Working Day Strategy

                </label>

                <div>

                    {schedule.working_day_strategy}

                </div>

            </div>

            <div className="col-md-4 mb-3">

                <label className="form-label fw-bold">

                    Generate Before Days

                </label>

                <div>

                    {schedule.generate_before_days}

                </div>

            </div>

            <div className="col-md-3 mb-3">

                <label className="form-label fw-bold">

                    Skip Holidays

                </label>

                <div>

                    <span
                        className={`badge ${
                            schedule.skip_holidays
                                ? "bg-success"
                                : "bg-secondary"
                        }`}
                    >

                        {schedule.skip_holidays
                            ? "Yes"
                            : "No"}

                    </span>

                </div>

            </div>

            <div className="col-md-3 mb-3">

                <label className="form-label fw-bold">

                    Skip Weekly Off

                </label>

                <div>

                    <span
                        className={`badge ${
                            schedule.skip_weekly_off
                                ? "bg-success"
                                : "bg-secondary"
                        }`}
                    >

                        {schedule.skip_weekly_off
                            ? "Yes"
                            : "No"}

                    </span>

                </div>

            </div>

            <div className="col-md-6 mb-3">

                <label className="form-label fw-bold">

                    Remarks

                </label>

                <div>

                    {schedule.remarks || "-"}

                </div>

            </div>

        </div>

    </div>

</div>
<div className="card mb-3">

    <div className="card-header">

        <strong>

            Execution History

        </strong>

    </div>

    <div className="card-body">

        {executionHistory.length === 0 ? (

            <div className="text-muted">

                No execution history available.

            </div>

        ) : (

            <div className="table-responsive">

                <table className="table table-bordered table-hover">

                    <thead className="table-light">

                        <tr>

                            <th width="170">

                                Scheduled

                            </th>

                            <th width="170">

                                Executed

                            </th>

                            <th width="150">

                                Work No

                            </th>

                            <th>

                                Title

                            </th>

                            <th width="120">

                                Status

                            </th>

                            <th width="120">

                                Priority

                            </th>

                            <th width="140">

                                Progress

                            </th>

                            <th width="90">

                                Action

                            </th>

                        </tr>

                    </thead>

                    <tbody>

                        {executionHistory.map(row => (

                            <tr key={row.execution_id}>

                                <td>

                                    {new Date(
                                        row.scheduled_date
                                    ).toLocaleDateString(
                                        "en-GB",
                                        {

                                            day: "2-digit",

                                            month: "short",

                                            year: "numeric"

                                        }
                                    )}

                                </td>

                                <td>

                                    {row.executed_on

                                        ? new Date(
                                            row.executed_on
                                        ).toLocaleString(
                                            "en-GB"
                                        )

                                        : "-"}

                                </td>

                                <td>

                                    <strong>

                                        {row.work_no}

                                    </strong>

                                </td>

                                <td>

                                    {row.title}

                                </td>

                                <td>

                                    <span
                                        className={`badge ${
                                            row.status === "OPEN"
                                                ? "bg-primary"
                                                : row.status === "COMPLETED"
                                                ? "bg-success"
                                                : row.status === "IN_PROGRESS"
                                                ? "bg-warning text-dark"
                                                : "bg-secondary"
                                        }`}
                                    >

                                        {row.status}

                                    </span>

                                </td>

                                <td>

                                    <span
                                        className="badge bg-secondary"
                                    >

                                        {row.priority}

                                    </span>

                                </td>

                                <td>

                                    <div
                                        className="progress"
                                        style={{
                                            height: 18
                                        }}
                                    >

                                        <div
                                            className="progress-bar"
                                            style={{
                                                width: `${row.completion_percentage}%`
                                            }}
                                        >

                                            {row.completion_percentage}%

                                        </div>

                                    </div>

                                </td>

                                <td>

                                    <button
                                        className="btn btn-sm btn-outline-primary"
                                        onClick={() =>

                                            window.open(

                                                `/wms/works/${row.work_id}`,

                                                "_blank"

                                            )

                                        }
                                    >

                                        <i className="fas fa-eye"/>

                                    </button>

                                </td>

                            </tr>

                        ))}

                    </tbody>

                </table>

            </div>

        )}

    </div>

</div>
<div className="card mb-3">

    <div className="card-header">

        <strong>

            Generated Works

        </strong>

    </div>

    <div className="card-body">

        {executionHistory.length === 0 ? (

            <div className="text-muted">

                No generated works.

            </div>

        ) : (

            <div className="table-responsive">

                <table className="table table-bordered table-hover">

                    <thead className="table-light">

                        <tr>

                            <th width="150">

                                Work No

                            </th>

                            <th>

                                Title

                            </th>

                            <th width="120">

                                Status

                            </th>

                            <th width="120">

                                Priority

                            </th>

                            <th width="150">

                                Progress

                            </th>

                            <th width="100">

                                Action

                            </th>

                        </tr>

                    </thead>

                    <tbody>

                        {executionHistory.map(work => (

                            <tr key={work.work_id}>

                                <td>

                                    <strong>

                                        {work.work_no}

                                    </strong>

                                </td>

                                <td>

                                    {work.title}

                                </td>

                                <td>

                                    <span
                                        className={`badge ${
                                            work.status === "OPEN"
                                                ? "bg-primary"
                                                : work.status === "COMPLETED"
                                                ? "bg-success"
                                                : work.status === "IN_PROGRESS"
                                                ? "bg-warning text-dark"
                                                : "bg-secondary"
                                        }`}
                                    >

                                        {work.status}

                                    </span>

                                </td>

                                <td>

                                    <span
                                        className="badge bg-secondary"
                                    >

                                        {work.priority}

                                    </span>

                                </td>

                                <td>

                                    <div
                                        className="progress"
                                        style={{
                                            height: 18
                                        }}
                                    >

                                        <div
                                            className="progress-bar"
                                            style={{
                                                width: `${work.completion_percentage}%`
                                            }}
                                        >

                                            {work.completion_percentage}%

                                        </div>

                                    </div>

                                </td>

                                <td>

                                    <button
                                        className="btn btn-sm btn-outline-primary"
                                        onClick={() =>

                                            window.open(

                                                `/wms/works/${work.work_id}`,

                                                "_blank"

                                            )

                                        }
                                    >

                                        <i className="fas fa-eye" />

                                    </button>

                                </td>

                            </tr>

                        ))}

                    </tbody>

                </table>

            </div>

        )}

    </div>

</div>

<div className="card mb-3">

    <div className="card-header">

        <strong>

            Audit Information

        </strong>

    </div>

    <div className="card-body">

        <div className="row">

            <div className="col-md-3 mb-3">

                <label className="form-label fw-bold">

                    Created By

                </label>

                <div>

                    {schedule.created_by || "-"}

                </div>

            </div>

            <div className="col-md-3 mb-3">

                <label className="form-label fw-bold">

                    Created On

                </label>

                <div>

                    {schedule.created_at
                        ? new Date(
                              schedule.created_at
                          ).toLocaleString("en-GB")
                        : "-"}

                </div>

            </div>

            <div className="col-md-3 mb-3">

                <label className="form-label fw-bold">

                    Updated By

                </label>

                <div>

                    {schedule.updated_by || "-"}

                </div>

            </div>

            <div className="col-md-3 mb-3">

                <label className="form-label fw-bold">

                    Updated On

                </label>

                <div>

                    {schedule.updated_at
                        ? new Date(
                              schedule.updated_at
                          ).toLocaleString("en-GB")
                        : "-"}

                </div>

            </div>

        </div>

    </div>

</div>

        </div>

    );

}

export default RecurringScheduleDetailsPage;